import { format, isValid, parse } from 'date-fns';
import { isoDateFormat } from '../utils/dates.ts';
import DateRangeFilter from '../../analytics/components/DateRangeFilter';
import * as React from 'react';
import { DateRange } from 'react-day-picker';
import { IFilter } from '../utils/filterQuery.ts';

interface DateRangePresetOption {
    label: string;
    value: string;
}

interface DateRangePresetFilterProps {
    filters: IFilter[];
    onFiltersChange: (filters: IFilter[]) => void;
    filterName: string;
    label: string;
    presetOptions: DateRangePresetOption[];
    maxDate?: Date;
}

const DateRangePresetFilter = ({
    filters,
    onFiltersChange,
    filterName,
    label,
    presetOptions,
    maxDate,
}: DateRangePresetFilterProps) => {
    const fromValue = filters.find((f) => f.name === filterName && f.expression === 'ge')?.value?.[0];
    const toValue = filters.find((f) => f.name === filterName && f.expression === 'le')?.value?.[0];

    const getDateValue = (value) => {
        return value && isValid(parse(value, isoDateFormat, new Date()))
            ? parse(value, isoDateFormat, new Date())
            : null;
    };

    const dateRange = {
        from: getDateValue(fromValue),
        to: getDateValue(toValue),
    };

    const handleDateChange = (range: DateRange) => {
        const updatedFilters = filters.filter((f) => f.name !== filterName);

        if (range.from) {
            updatedFilters.push({
                name: filterName,
                value: [format(range.from, isoDateFormat)],
                expression: 'ge',
                exclude: false,
            });
        }

        if (range.to) {
            updatedFilters.push({
                name: filterName,
                value: [format(range.to, isoDateFormat)],
                expression: 'le',
                exclude: false,
            });
        }

        onFiltersChange(updatedFilters);
    };

    return (
        <DateRangeFilter
            options={presetOptions.map((o) => ({ label: o.label, value: o.value }))}
            label={label}
            range={dateRange}
            onRangeChange={handleDateChange}
            maxDate={maxDate}
        />
    );
};

export default DateRangePresetFilter;
